const normalizeStatus = (value: unknown): string => String(value ?? '').trim().toLowerCase();

const ELIGIBLE_APPLICATION_STATUSES = new Set([
  'accepted',
  'accepted_pending_enrollment',
  'enrolled',
]);

const EXCLUDED_CHILD_STATUSES = new Set([
  'acceptance_expired',
  'denied',
  'waitlisted',
  'withdrawn',
]);

export const isEnrollmentTuitionEligible = (input: {
  applicationStatus: unknown;
  childStatus?: unknown;
}): boolean => {
  const applicationStatus = normalizeStatus(input.applicationStatus);
  if (!ELIGIBLE_APPLICATION_STATUSES.has(applicationStatus)) {
    return false;
  }

  const childStatus = normalizeStatus(input.childStatus) || applicationStatus;
  return !EXCLUDED_CHILD_STATUSES.has(childStatus);
};
